<template>
  <DModal :show-close="false" :isBgOverlay="true" :isCloseOnBgClick="false" @close="$emit('close')" :appendToBody="true"
          style="z-index: 12312312312312" :placeInTop="true">
    <div class="d-modal text-dark" slot="insertComponent">
      <div class="d-modal__header">
        <div>
          <h2>{{ employmentIds.length === 1 ? 'Opret engangsydelse' : 'Opret engangsydelser' }}</h2>
          <p class="d-modal__subtitle">{{ subtitleText }}</p>
        </div>
        <div class="font-large icon__bg-circle d-modal__header__close" @click="$emit('close')">
          <span class="icon-cross2"></span>
        </div>
      </div>

      <div class="d-modal__content">
        <div class="create-form__grid">
          <div class="d-input-group cf-loenart">
            <label class="d-label">Lønkode *</label>
            <DSelect
              ref="loenartSelect"
              :items="salaryCodesForDSelect"
              :multiple="false"
              :placeholder="'Vælg lønkode'"
              :itemsSelected="selectedSalaryCodeForDSelect"
              :isShowRemoveButton="false"
              @add="onSelectLoenart"
              @remove="onSelectLoenart(null)"
            />
          </div>
          <div class="d-input-group cf-antal">
            <label class="d-label">{{ beloebAllowed ? 'Antal' : 'Antal *' }}</label>
            <input v-model="antal" type="text" inputmode="decimal" class="d-input width-100" placeholder="Indtast antal"/>
          </div>
          <div class="d-input-group cf-beloeb">
            <label class="d-label">{{ beloebAllowed ? 'Beløb *' : 'Beløb' }}</label>
            <span class="cf-beloeb__field"
                  :content="beloebAllowed ? '' : 'Kræver løbenummer 0'"
                  v-tippy="{
                    arrow: true,
                    placement: 'top',
                    animateFill: false,
                    animation: 'shift-away',
                    boundary: 'window',
                    zIndex: 12312312312312,
                    onShow: () => !beloebAllowed
                  }">
              <input v-model="beloeb" type="text" inputmode="decimal" class="d-input width-100"
                     :disabled="!beloebAllowed"
                     :placeholder="beloebAllowed ? 'Indtast beløb' : ''"/>
            </span>
          </div>
          <p class="cf-hint text-explainer">
            {{ beloebHint }}
          </p>
          <div class="d-input-group cf-dato">
            <label class="d-label">Aktivitetsdato *</label>
            <DateSelector class="width-100" :date="dato" :width100="true" @changed="setDato($event)"/>
          </div>
          <div class="d-input-group cf-omk">
            <label class="d-label">Afvigende omkostningssted</label>
            <DSelect
              :items="costCentersForDSelect"
              :multiple="false"
              :placeholder="'Vælg afvigende omkostningssted (valgfri)'"
              :itemsSelected="selectedCostCenterForDSelect"
              :isShowRemoveButton="true"
              @add="onSelectCostCenter"
              @remove="onSelectCostCenter(null)"
            />
          </div>
        </div>
        <p v-if="validationMessage" class="text-explainer text-explainer--danger">{{ validationMessage }}</p>
      </div>

      <div class="d-modal__buttons">
        <div class="d-modal__buttons__child">
          <button class="do-bttn" @click="$emit('close')">{{ $t('vue2.common.cancel') }}</button>
          <button class="do-bttn do-bttn--submit"
                  :class="{'do-bttn--submit--loading': isSubmitting, 'do-bttn--submit--disabled': !isValid}"
                  :disabled="!isValid || isSubmitting"
                  @click="submit"
                  :content="saveKeyTooltip"
                  v-tippy="{
                    arrow: true,
                      placement : 'right',
                      animateFill: false,
                      animation : 'shift-away',
                      boundary: 'window',
                      zIndex: 12312312312312
                    }">
            {{ submitButtonLabel }}
          </button>
        </div>
      </div>
    </div>
  </DModal>
</template>

<script>
import DModal from '../../common/DModal.vue'
import DateSelector from '../../datepicker/DateSelector.vue'
import moment from 'moment'
import eventbus from '../../../eventbus'
import docendo from '../../../docendo'
import DSelect from '../../DSelect/DSelect.vue'

export default {
  components: {DSelect, DModal, DateSelector},
  props: {
    schoolId: {
      type: Number,
      required: true
    },
    employmentIds: {
      type: Array,
      default: () => []
    },
    subtitle: {
      type: String,
      default: ''
    },
    // Forudfyldte værdier, fx ved modpostering: { salaryCodeId, antal, beloeb, dato }
    prefill: {
      type: Object,
      default: null
    }
  },
  data () {
    const prefill = this.prefill || {}
    return {
      dato: prefill.dato ? moment(prefill.dato) : moment(),
      salaryCodeId: prefill.salaryCodeId != null ? prefill.salaryCodeId : null,
      salaryCostCenterId: null,
      antal: prefill.antal != null ? String(prefill.antal) : '',
      beloeb: prefill.beloeb != null ? String(prefill.beloeb) : '',
      isSubmitting: false,
      validationMessage: ''
    }
  },
  computed: {
    metaKey () {
      const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0
      return isMac ? '⌘' : 'CTRL'
    },
    saveKeyTooltip () {
      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span>' + '<span>Enter</span></p>'
    },
    subtitleText () {
      if (this.subtitle) return this.subtitle
      return 'På ' + this.employmentIds.length + ' ' + (this.employmentIds.length === 1 ? 'ansættelse' : 'ansættelser')
    },
    submitButtonLabel () {
      if (this.employmentIds.length <= 1) {
        return 'Opret engangsydelse'
      }
      return 'Opret ' + this.employmentIds.length + ' engangsydelser'
    },
    isValid () {
      const hasEmployments = this.employmentIds.length > 0
      const hasDato = !!this.dato && moment(this.dato).isValid()
      const hasLoenart = this.salaryCodeId != null
      const hasAntal = this.antal !== '' && this.antal != null
      const hasBeloeb = this.beloeb !== '' && this.beloeb != null
      // KMD kode 171: Beløb er obligatorisk når løbenummer er 0 – og kun tilladt der.
      // Uden beløb skal Antal udfyldes (taksten for lønarten anvendes).
      const beloebRule = this.beloebAllowed ? hasBeloeb : hasAntal
      return hasEmployments && hasDato && hasLoenart && beloebRule && this.antalValid && this.beloebValid
    },
    // Antal er valgfri, men hvis udfyldt: -999,99 til 9.999,99 (jf. KMD's grænser).
    antalValid () {
      if (this.antal === '' || this.antal == null) return true
      const antal = parseFloat(String(this.antal).replace(',', '.'))
      return !isNaN(antal) && antal >= -999.99 && antal <= 9999.99
    },
    // Beløb er valgfrit, men hvis udfyldt: max 99999,99 (jf. KMD's grænse på 8 cifre).
    beloebValid () {
      if (this.beloeb === '' || this.beloeb == null) return true
      const beloeb = parseFloat(String(this.beloeb).replace(',', '.'))
      return !isNaN(beloeb) && Math.abs(beloeb) <= 99999.99
    },
    salaryCodes () {
      return this.$store.getters.salaryCodesSorted || []
    },
    salaryCodesForDSelect () {
      if (!this.salaryCodes || !Array.isArray(this.salaryCodes)) {
        return []
      }
      return this.salaryCodes
        .filter(sc => sc.loenart)
        .map(sc => {
          const value = sc.loenart != null ? sc.loenart : sc.code
          const displayValue = value != null ? String(value) : ''
          const name = sc.name || ''
          return {
            id: sc.id,
            name: displayValue + (name ? ' - ' + name : ''),
            value: value,
            original: sc
          }
        })
    },
    selectedSalaryCodeForDSelect () {
      if (this.salaryCodeId == null) {
        return []
      }
      const found = this.salaryCodesForDSelect.find(item => item.id === this.salaryCodeId)
      return found ? [found] : []
    },
    selectedSalaryCode () {
      const found = this.salaryCodesForDSelect.find(item => item.id === this.salaryCodeId)
      return found ? found.original : null
    },
    // KMD: Beløb må kun indberettes når løbenummer er 0 (fejlkode 171).
    // Løbenummeret er lønkodens sidste ciffer.
    beloebAllowed () {
      return !!this.selectedSalaryCode && String(this.selectedSalaryCode.loenart).slice(-1) === '0'
    },
    beloebHint () {
      if (this.beloebAllowed) {
        return 'Lønkoden har løbenummer 0, så Beløb skal udfyldes. Antal er valgfrit og ganges på beløbet.'
      }
      if (this.selectedSalaryCode) {
        return 'Angiv Antal – taksten for lønkoden anvendes. Beløb kan kun angives for lønkoder med løbenummer 0 (sidste ciffer).'
      }
      return 'Beløb kan kun angives for lønkoder med løbenummer 0 (sidste ciffer); ellers angives Antal.'
    },
    costCenters () {
      return this.$store.getters.costCenters || []
    },
    costCentersForDSelect () {
      return this.costCenters.map(cc => {
        const code = cc.code != null ? String(cc.code) : ''
        const title = cc.title || cc.name || ''
        return {
          id: cc.id,
          name: code + (title ? ' - ' + title : ''),
          value: code,
          original: cc
        }
      })
    },
    selectedCostCenterForDSelect () {
      if (this.salaryCostCenterId == null) {
        return []
      }
      const found = this.costCentersForDSelect.find(item => item.id === this.salaryCostCenterId)
      return found ? [found] : []
    }
  },
  watch: {
    // Ryd et indtastet beløb hvis brugeren skifter til en lønart, hvor beløb ikke er tilladt,
    // så der ikke hænger en skjult værdi ved i payloaden.
    beloebAllowed (allowed) {
      if (!allowed) {
        this.beloeb = ''
      }
    }
  },
  methods: {
    onSelectLoenart (item) {
      this.salaryCodeId = item ? item.id : null
    },
    onSelectCostCenter (item) {
      this.salaryCostCenterId = item ? item.id : null
    },
    setDato (date) {
      this.dato = date
    },
    onGlobalKeydown (evt) {
      const isSubmitCombo = (evt.metaKey || evt.ctrlKey) && (evt.key === 'Enter' || evt.keyCode === 13)
      if (!isSubmitCombo) return

      if (this.isSubmitting || !this.isValid) return

      evt.preventDefault()
      this.submit()
    },
    submit () {
      this.validationMessage = ''
      if (!this.isValid) {
        this.validationMessage = 'Udfyld alle obligatoriske felter'
        return
      }
      if (!this.schoolId) {
        this.validationMessage = 'Mangler schoolId'
        return
      }

      // Backenden udleder selv lønart/løbenummer fra salary_code_id og omkostningssted fra salary_cost_center_id.
      const engangsydelse = {
        dato: moment(this.dato).format('YYYY-MM-DD'),
        salary_code_id: this.salaryCodeId
      }
      if (this.antal !== '' && this.antal != null) {
        engangsydelse.antal = parseFloat(String(this.antal).replace(',', '.'))
      }
      if (this.beloeb !== '' && this.beloeb != null) {
        engangsydelse.beloeb = parseFloat(String(this.beloeb).replace(',', '.'))
      }
      if (this.salaryCostCenterId != null) {
        engangsydelse.salary_cost_center_id = this.salaryCostCenterId
      }

      this.isSubmitting = true
      docendo.createKmdEngangsydelseForEmployees(
        this.schoolId,
        this.employmentIds,
        engangsydelse,
        success => {
          this.isSubmitting = false
          if (success && success.status === 'error') {
            this.validationMessage = success.message || 'Kunne ikke oprette engangsydelser'
            eventbus.toast = {text: 'Kunne ikke oprette engangsydelser', success: false, position: 'bottomLeft'}
            return
          }
          const count = Array.isArray(success) ? success.length : this.employmentIds.length
          eventbus.toast = {
            text: (count === 1 ? 'Engangsydelse' : count + ' engangsydelser') + ' sendt til behandling. Følg status i listen.',
            success: true,
            position: 'bottomLeft'
          }
          this.$emit('created', success)
          this.$emit('close')
        },
        failure => {
          console.log('failure', failure)
          this.isSubmitting = false
          eventbus.toast = {text: 'Kunne ikke oprette engangsydelser', success: false, position: 'bottomLeft'}
        }
      )
    }
  },
  mounted () {
    this.$store.dispatch('readSalaryCodes')
    this.$store.dispatch('readCostCenters')
    window.addEventListener('keydown', this.onGlobalKeydown)
    // Lås baggrundens scroll mens modalen er åben. Husk om det var os der
    // tilføjede klassen, så vi ikke fjerner en lås sat af en anden modal.
    this.didAddNoScroll = !document.body.classList.contains('no-scroll')
    if (this.didAddNoScroll) {
      document.body.classList.add('no-scroll')
    }
    // Fokusér lønart-feltet uden at åbne dropdownen; den åbner først når brugeren taster.
    this.$nextTick(() => {
      setTimeout(() => {
        if (this.$refs.loenartSelect) this.$refs.loenartSelect.setFocus()
      }, 300)
    })
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.onGlobalKeydown)
    if (this.didAddNoScroll) {
      document.body.classList.remove('no-scroll')
    }
  }
}
</script>

<style scoped>
@import "../../../assets/css/variables.css";

.d-modal {
  width: 600px;
  max-width: calc(100vw - 32px);
  border-radius: 16px;
  position: relative;
}

.d-modal__header {
  margin-bottom: 0;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.d-modal__subtitle {
  margin: 0.25rem 0 0;
  font-size: 13px;
  color: #6b7280;
}

.d-modal__buttons {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1rem 2rem;
  border-top: 1px solid #eee;
  margin: 0;
}

.d-modal__buttons__child {
  display: flex;
  gap: 0.5rem;
}

.d-modal__content {
  padding: 1rem;
  overscroll-behavior: contain;
  max-height: calc(100vh - 52px - 80px);
  overflow-y: auto;
}

.create-form__grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
}

/* Eksplicit placering så relaterede felter grupperes logisk. */
.cf-loenart {
  grid-column: 1 / -1;
  grid-row: 1;
}

.cf-antal {
  grid-column: 1;
  grid-row: 2;
}

.cf-beloeb {
  grid-column: 2;
  grid-row: 2;
}

.cf-hint {
  grid-column: 1 / -1;
  grid-row: 3;
  margin: -0.25rem 0 0;
  padding: 0 1rem;
}

.cf-dato {
  grid-column: 1;
  grid-row: 4;
}

.cf-omk {
  grid-column: 2;
  grid-row: 4;
}

.d-input-group .d-input {
  height: 34px;
}

.cf-beloeb__field {
  display: block;
  width: 100%;
}

/* Sikr at hover rammer wrapperen (og dermed tooltippet), også når feltet er disabled. */
.cf-beloeb__field input:disabled {
  pointer-events: none;
}

.d-input-group .d-input:disabled {
  background: #f3f4f6;
  color: #9ca3af;
  cursor: not-allowed;
}

.d-input-group {
  margin-bottom: 0.5rem;
}

.text-explainer--danger {
  color: var(--danger);
  margin-top: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// CreateEngangsydelse.vue?55bd94d4